import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { LabelPrice } from "../LabelPrice/LabelPrice";
import { ELabelPriceVariant } from "../LabelPrice/ELabelPriceVariant";
import { useStyle } from "./style";

interface IParams {
    arePricesLoading?: boolean;
    description: string;
    monthlyAmount: number;
    upfrontAmount: number;
    quantity: number;
}

export const FlyingCartItem = (props: IParams) => {
    const { t } = useTranslation(["cart", "common"]);
    const { classes } = useStyle();

    const { description, monthlyAmount, upfrontAmount, quantity, arePricesLoading } = props;

    return (
        <Box className={classes.flyingCartItem}>
            <Typography className={classes.flyingCartItemTitle}>
                {quantity} x {description}
            </Typography>
            <LabelPrice
                isLoading={arePricesLoading}
                label={t("cart:monthly")}
                price={monthlyAmount}
                variant={ELabelPriceVariant.ITEM}
            />
            {upfrontAmount > 0 && (
                <LabelPrice
                    isLoading={arePricesLoading}
                    label={t("cart:oneTimeActivation")}
                    price={upfrontAmount}
                    variant={ELabelPriceVariant.ITEM}
                />
            )}
        </Box>
    );
};
